import { IMAGE_DESKTOP, IMAGE_MOBILE, ICON_FIELD } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const CUSTOMER_STORIES = `
...on customerStories_Entry {
  id
  typeHandle
  headingAdvanced {
    html
  }

  cards: customerStoriesMatrix {
    id
    ${ ICON_FIELD }

    badge
    customerName
    text
    ${ LINK_FIELD }

    ${ IMAGE_MOBILE }
    ${ IMAGE_DESKTOP }
  }
}
`